module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/empresa/empresa.component.css
// module id = ./src/app/empresa/empresa.component.css
// module chunks = main